"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumb as ChakraBreadcrumb, Flex, forwardRef, } from "@chakra-ui/react";
import { SvgSpriteConsumer } from "../SvgSprite";
const Breadcrumb = forwardRef((_a, ref) => {
    var { withBackground, children } = _a, rest = __rest(_a, ["withBackground", "children"]);
    return (_jsx(ChakraBreadcrumb, Object.assign({ spacing: "8px", separator: _jsx(Flex, { children: _jsx(SvgSpriteConsumer, { svgId: "chevronRight16", size: 16 }) }), sx: withBackground
            ? {
                backgroundColor: "semantic.surface.1",
                px: { sm: "6", md: "10" },
                py: { sm: "4", md: "6" },
                width: "100%",
            }
            : undefined, ref: ref }, rest, { children: children })));
});
Breadcrumb.displayName = "Breadcrumb";
export default Breadcrumb;
//# sourceMappingURL=Breadcrumb.js.map